import { LAUNCHER_SUBDOMAIN, REGISTER_SUBDOMAIN, TESTNET_SUBDOMAIN, VC_SUBDOMAIN } from '../constants/links'

export function roundToDecimalPlace(numberString: string, decimalPlaces: string) {
  const num = Number(numberString)
  const decimal = Number(decimalPlaces)

  const factor = Math.pow(10, decimal)

  const rounded = Math.trunc(num * factor) / factor

  const [integerPart, decimalPart] = rounded.toFixed(decimal).split('.')

  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart
}

export const getSubdomain = () => {
  const hostname = window.location.hostname
  const subdomain = hostname.split('.')[0]
  return subdomain
}

export const isVCSubdomain = () => {
  return getSubdomain() === VC_SUBDOMAIN
}

export const isLauncherSubdomain = () => {
  return getSubdomain() === LAUNCHER_SUBDOMAIN
}

export const isTestnetSubdomain = () => {
  return getSubdomain().includes(TESTNET_SUBDOMAIN)
}

export const isRegisterSubdomain = () => {
  return getSubdomain().includes(REGISTER_SUBDOMAIN)
}

export const isStaging = () => {
  return getSubdomain().includes('staging')
}

export const isLocalhost = () => {
  return window.location.hostname.match(/localhost/)
}
